import { all, put, takeLatest } from "redux-saga/effects";

import store from "../../store/store";
import {
  hideLoader,
  showLoader,
} from "../../component-lib/Molecules/loader/LoaderSlice";
import { eventEHRCustomToastMessage } from "../../component-lib/Atoms/custom-toast-message/EventEHRCustomToastMessage";
import FacilityManagementService from "../../services/FacilityManagementService";
import {
  componentKey,
  getClinicLocationData,
  getPatientListData,
  setBaseCampDetails,
  setCloseAddFacilityDialog,
  setCloseCreatePatientDrawer,
  setCloseDepartmentDialog,
  setDepartmentList,
  setFacilityList,
  getInventoriesListData,
  setCloseFacilityInventoryAddData,
  setRolesList,
  setCloseUserDialog,
  setFacilityUserList,
  setDeleteFacilityResponse,
  setDeleteDepartmentResponse,
  setRoomList,
  setCloseRoomDialog,
  setGroupedNotesData,
  setCloseAddNotesDialog,
  setCloseSendBulkDialog,
} from "./FacilityManagementSlice";

export const {
  getFacilityList,
  postFacilityData,
  patchFacilityData,
  getFacilityById,
  addDepartment,
  getDepartmentList,
  patchDepartmentData,
  getClinicLocations,
  getPatientList,
  getFacilityInventoryList,
  createNewPatient,
  createFacilityInventory,
  patchAddFacilityInventory,
  deleteFacilityInventory,
  postInventoryNotes,
  getInventoryNotesGroupedByIds,
  postBulkTransfer,
  getRolesList,
  addNewFacilityUser,
  getFacilityUserList,
  patchFacilityUser,
  deleteFacilityUser,
  sendFacilityUserInvitation,
  sendFacilityUserBulkInvitation,
  deleteFacility,
  deleteDepartment,
  addRoom,
  getRoomList,
  patchRoomData,
  deleteRoom,
} = {
  getFacilityList: (payload) => {
    return {
      type: "FACILITY/GET_FACILITY_LIST",
      payload,
    };
  },
  getFacilityById: (payload) => {
    return {
      type: "FACILITY/GET_FACILITY_BY_ID",
      payload,
    };
  },
  postFacilityData: (payload) => {
    return {
      type: "FACILITY/POST_FACILITY_DATA",
      payload,
    };
  },
  patchFacilityData: (payload) => {
    return {
      type: "FACILITY/PATCH_FACILITY_DATA",
      payload,
    };
  },

  addDepartment: (payload) => {
    return {
      type: "FACILITY/ADD_DEPARTMENT",
      payload,
    };
  },
  getDepartmentList: (payload) => {
    return {
      type: "FACILITY/GET_DEPARTMENT",
      payload,
    };
  },

  patchDepartmentData: (payload) => {
    return {
      type: "FACILITY/UPDATE_DEPARTMENT",
      payload,
    };
  },
  getClinicLocations: (payload) => {
    return {
      type: "PATIENT/GET_CLINIC_LOCATIONS",
      payload,
    };
  },
  getPatientList: (payload) => {
    return {
      type: "PATIENT/GET_PATIENT_LIST",
      payload,
    };
  },

  createNewPatient: (payload) => {
    return {
      type: "PATIENT/CREATE_NEW_PATIENT",
      payload,
    };
  },
  getFacilityInventoryList: (payload) => {
    return {
      type: "INVENTORY/GET_INVENTORY_FACILITY_LIST",
      payload,
    };
  },
  createFacilityInventory: (payload) => {
    return {
      type: "INVENTORY/CREATE_FACILITY_INVENTORY",
      payload,
    };
  },
  patchAddFacilityInventory: (payload) => {
    return {
      type: "INVENTORY/PATCH_FACILITY_INVENTORY",
      payload,
    };
  },
  deleteFacilityInventory: (payload) => {
    return {
      type: "INVENTORY/DELETE_FACILITY_INVENTORY",
      payload,
    };
  },
  postInventoryNotes: (payload) => {
    return {
      type: "INVENTORY/POST_INVENTORY_NOTES",
      payload,
    };
  },
  getInventoryNotesGroupedByIds: (payload) => {
    return {
      type: "INVENTORY/GET_GROUPED_NOTES",
      payload,
    };
  },
  postBulkTransfer: (payload) => {
    return {
      type: "INVENTORY/POST_BULK_TRANSFER",
      payload,
    };
  },

  getRolesList: (payload) => {
    return {
      type: "FACILITY/USER/GET_ROLES_LIST",
      payload,
    };
  },

  addNewFacilityUser: (payload) => {
    return {
      type: "FACILITY/USER/ADD_NEW_FACILITY_USER",
      payload,
    };
  },

  getFacilityUserList: (payload) => {
    return {
      type: "FACILITY/USER/GET_FACILITY_USER_LIST",
      payload,
    };
  },
  patchFacilityUser: (payload) => {
    return {
      type: "FACILITY/USER/PATCH_FACILITY_USER_LIST",
      payload,
    };
  },
  deleteFacilityUser: (payload) => {
    return {
      type: "FACILITY/USER/DELETE_FACILITY_USER",
      payload,
    };
  },
  sendFacilityUserInvitation: (payload) => {
    return {
      type: "FACILITY/USER/SEND_INVITATION",
      payload,
    };
  },
  sendFacilityUserBulkInvitation: (payload) => {
    return {
      type: "FACILITY/USER/SEND_BULK_INVITATION",
      payload,
    };
  },
  deleteFacility: (payload) => {
    return {
      type: "FACILITY/DELETE_FACILITY",
      payload,
    };
  },
  deleteDepartment: (payload) => {
    return {
      type: "FACILITY/DEPARTMENT/DELETE_DEPARTMENT",
      payload,
    };
  },
  addRoom: (payload) => {
    return {
      type: "FACILITY/ADD_ROOM",
      payload,
    };
  },
  getRoomList: (payload) => {
    return {
      type: "FACILITY/GET_ROOM",
      payload,
    };
  },
  patchRoomData: (payload) => {
    return {
      type: "FACILITY/UPDATE_ROOM",
      payload,
    };
  },
  deleteRoom: (payload) => {
    return {
      type: "FACILITY/DELETE_ROOM",
      payload,
    };
  },
};

// POST FACILITY DATA ASYNC
function* postFacilityDataAsync(action) {
  try {
    yield put(showLoader());
    const response = yield FacilityManagementService.postFacilityData(
      action?.payload
    );
    const { status } = response;
    if (status) {
      const { data, message } = response?.data;
      console.log(data);

      eventEHRCustomToastMessage({
        title: `${message}`,
        status: "success",
      });
      yield put(setCloseAddFacilityDialog(true));
    }
  } catch (error) {
    eventEHRCustomToastMessage({
      title: `${error?.response?.data?.message}`,
      status: "error",
    });
    yield put(setCloseAddFacilityDialog(false));
    console.log("err: ", error);
  } finally {
    yield put(hideLoader());
  }
}

// GET TASK DATA ASYNC
function* getFacilityListAsync(action) {
  // Silent polling (auto-refresh) skips the global loader.
  const silent = action?.payload?.silent;
  try {
    if (!silent) yield put(showLoader());
    const response = yield FacilityManagementService.getFacilityList(
      action?.payload
    );
    const { status, data } = response;
    if (status) {
      yield put(setFacilityList(data));
    }
  } catch (error) {
    eventEHRCustomToastMessage({
      title: `${error?.response?.data?.message}`,
      status: "error",
    });
    yield put(setFacilityList({}));
    console.log("err: ", error);
  } finally {
    if (!silent) yield put(hideLoader());
  }
}

// PATCH FACILITY DATA ASYNC
function* patchFacilityDataAsync(action) {
  const { facilityId, payload } = action?.payload;
  try {
    yield put(showLoader());
    const response = yield FacilityManagementService.patchFacilityData(
      facilityId,
      payload
    );
    const { status } = response;
    if (status) {
      const { data, message } = response?.data;
      console.log(data);

      eventEHRCustomToastMessage({
        title: `${message}`,
        status: "success",
      });
      yield put(setCloseAddFacilityDialog(true));
    }
  } catch (error) {
    eventEHRCustomToastMessage({
      title: `${error?.response?.data?.message}`,
      status: "error",
    });
    yield put(setCloseAddFacilityDialog(false));
    console.log("err: ", error);
  } finally {
    yield put(hideLoader());
  }
}

// GET FACILITY LIST BY ID ASYNC
function* getFacilityByIdAsync(action) {
  try {
    yield put(showLoader());
    const response = yield FacilityManagementService.getFacilityById(
      action?.payload
    );
    const { status, data } = response;
    if (status) {
      yield put(setBaseCampDetails(data));
    }
  } catch (error) {
    eventEHRCustomToastMessage({
      title: `${error?.response?.data?.message}`,
      status: "error",
    });
    yield put(setBaseCampDetails({}));
    console.log("err: ", error);
  } finally {
    yield put(hideLoader());
  }
}

// POST FACILITY DATA ASYNC
function* addDepartmentAsync(action) {
  try {
    yield put(showLoader());
    const response = yield FacilityManagementService.addDepartment(
      action?.payload
    );
    const { status } = response;
    if (status) {
      const { data, message } = response?.data;
      console.log(data);

      eventEHRCustomToastMessage({
        title: `${message}`,
        status: "success",
      });
      yield put(setCloseDepartmentDialog(true));
    }
  } catch (error) {
    eventEHRCustomToastMessage({
      title: `${error?.response?.data?.message}`,
      status: "error",
    });
    yield put(setCloseDepartmentDialog(false));
    console.log("err: ", error);
  } finally {
    yield put(hideLoader());
  }
}

// GET TASK DATA ASYNC
function* getDepartmentListAsync(action) {
  try {
    yield put(showLoader());
    const response = yield FacilityManagementService.getDepartmentList(
      action?.payload
    );
    const { status, data } = response;
    if (status) {
      yield put(setDepartmentList(data));
    }
  } catch (error) {
    eventEHRCustomToastMessage({
      title: `${error?.response?.data?.message}`,
      status: "error",
    });
    yield put(setDepartmentList({}));
    console.log("err: ", error);
  } finally {
    yield put(hideLoader());
  }
}

// ADD ROOM ASYNC
function* addRoomAsync(action) {
  try {
    yield put(showLoader());
    const response = yield FacilityManagementService.addRoom(action?.payload);
    const { status } = response;
    if (status) {
      const message = response?.data?.message;
      eventEHRCustomToastMessage({
        title: `${message}`,
        status: "success",
      });
      yield put(setCloseRoomDialog(true));
    }
  } catch (error) {
    eventEHRCustomToastMessage({
      title: `${error?.response?.data?.message}`,
      status: "error",
    });
    yield put(setCloseRoomDialog(false));
    console.log("err: ", error);
  } finally {
    yield put(hideLoader());
  }
}

// GET ROOM LIST ASYNC
function* getRoomListAsync(action) {
  try {
    yield put(showLoader());
    const response = yield FacilityManagementService.getRoomList(
      action?.payload
    );
    const { status, data } = response;
    if (status) {
      yield put(setRoomList(data));
    }
  } catch (error) {
    eventEHRCustomToastMessage({
      title: `${error?.response?.data?.message}`,
      status: "error",
    });
    yield put(setRoomList({}));
    console.log("err: ", error);
  } finally {
    yield put(hideLoader());
  }
}

// UPDATE ROOM ASYNC
function* patchRoomDataAsync(action) {
  const { roomId, payload } = action?.payload;
  try {
    yield put(showLoader());
    const response = yield FacilityManagementService.patchRoom(roomId, payload);
    const { status } = response;
    if (status) {
      const message = response?.data?.message;
      eventEHRCustomToastMessage({
        title: `${message}`,
        status: "success",
      });
      yield put(setCloseRoomDialog(true));
    }
  } catch (error) {
    eventEHRCustomToastMessage({
      title: `${error?.response?.data?.message}`,
      status: "error",
    });
    yield put(setCloseRoomDialog(false));
    console.log("err: ", error);
  } finally {
    yield put(hideLoader());
  }
}

// DELETE ROOM ASYNC
function* deleteRoomAsync(action) {
  const { roomId } = action?.payload;
  try {
    yield put(showLoader());
    const response = yield FacilityManagementService.deleteRoom(roomId);
    const { status } = response;
    if (status) {
      const message = response?.data?.message;
      eventEHRCustomToastMessage({
        title: `${message}`,
        status: "success",
      });
      yield put(setCloseRoomDialog(true));
    }
  } catch (error) {
    eventEHRCustomToastMessage({
      title: `${error?.response?.data?.message}`,
      status: "error",
    });
    console.log("err: ", error);
  } finally {
    yield put(hideLoader());
  }
}

// PATCH DEPARTMENT DATA ASYNC
function* patchDepartmentDataAsync(action) {
  const { departmentId, payload } = action?.payload;
  try {
    yield put(showLoader());
    const response = yield FacilityManagementService.patchDepartmentData(
      departmentId,
      payload
    );
    const { status } = response;
    if (status) {
      const { data, message } = response?.data;
      console.log(data);

      eventEHRCustomToastMessage({
        title: `${message}`,
        status: "success",
      });
      yield put(setCloseDepartmentDialog(true));
    }
  } catch (error) {
    eventEHRCustomToastMessage({
      title: `${error?.response?.data?.message}`,
      status: "error",
    });
    yield put(setCloseDepartmentDialog(false));
    console.log("err: ", error);
  } finally {
    yield put(hideLoader());
  }
}

// GET CLINIC LOCATIONS API CALL FUNCTION
function* getClinicLocationsAsync(action) {
  try {
    yield put(showLoader());
    const response = yield FacilityManagementService.getClinicLocations();
    const { status } = response;
    if (status) {
      const { basecamp } = response?.data;
      yield put(getClinicLocationData(basecamp));
    }
  } catch (error) {
    eventEHRCustomToastMessage({
      title: `${error?.response?.data?.message}`,
      status: "error",
    });
    console.log("err: ", error);
  } finally {
    yield put(hideLoader());
  }
}

// GET PATIENT API CALL FUNCTION
function* getPatientListAsync(action) {
  // Silent polling (auto-refresh) skips the global loader.
  const silent = action?.payload?.silent;
  try {
    if (!silent) yield put(showLoader());
    const response = yield FacilityManagementService.getPatientList(
      action?.payload
    );
    const { status } = response;
    if (status) {
      const { data } = response;
      yield put(getPatientListData(data));
    }
  } catch (error) {
    eventEHRCustomToastMessage({
      title: `${error?.response?.data?.message}`,
      status: "error",
    });
    yield put(getPatientListData({}));

    console.log("err: ", error);
  } finally {
    if (!silent) yield put(hideLoader());
  }
}

// CREATE NEW PATIENT API CALL FUNCTION
function* createNewPatientAsync(action) {
  try {
    yield put(showLoader());
    const response = yield FacilityManagementService.createNewPatient(
      action.payload?.apiPayload
    );
    const { status } = response;
    if (status) {
      const { message, patient } = response?.data;
      eventEHRCustomToastMessage({
        title: `${message}`,
        status: "success",
      });
      yield put(setCloseCreatePatientDrawer(true));
    }
  } catch (error) {
    eventEHRCustomToastMessage({
      title: `${error?.response?.data?.message}`,
      status: "error",
    });
    yield put(setCloseCreatePatientDrawer(false));
    console.log("err: ", error);
  } finally {
    yield put(hideLoader());
  }
}

// GET TASK DATA ASYNC
function* getFacilityInventoryListAsync(action) {
  try {
    yield put(showLoader());
    const response = yield FacilityManagementService.getInventoryListData(
      action?.payload
    );
    console.log("response", response);

    const { status, data } = response;
    if (status) {
      yield put(getInventoriesListData(data));
    }
  } catch (error) {
    eventEHRCustomToastMessage({
      title: `${error?.response?.data?.message}`,
      status: "error",
    });
    yield put(getInventoriesListData({}));
    console.log("err: ", error);
  } finally {
    yield put(hideLoader());
  }
}

function* createFacilityInventoryDataAsync(action) {
  try {
    yield put(showLoader);

    const response =
      yield FacilityManagementService.createFacilityInventoryData(
        action?.payload
      );

    const { status, data } = response;
    if (status) {
      const { message } = data;
      eventEHRCustomToastMessage({
        title: `${message}`,
        status: "success",
      });
      yield put(setCloseFacilityInventoryAddData(true));
    }
  } catch (error) {
    eventEHRCustomToastMessage({
      title: `${error?.response?.data?.message}`,
      status: "error",
    });
    yield put(setCloseFacilityInventoryAddData(false));
    console.log("err: ", error);
  } finally {
    yield put(hideLoader());
  }
}

function* patchAddFacilityInventoryDataAsync(action) {
  const { id, payload } = action?.payload;
  try {
    yield put(showLoader());
    const response = yield FacilityManagementService.patchFacilityInventoryData(
      id,
      payload
    );
    const { status } = response;
    if (status) {
      const { data, message } = response?.data;
      console.log("patch data", data);

      eventEHRCustomToastMessage({
        title: `${message}`,
        status: "success",
      });
      yield put(setCloseFacilityInventoryAddData(true));
    }
  } catch (error) {
    eventEHRCustomToastMessage({
      title: `${error?.response?.data?.message}`,
      status: "error",
    });
    yield put(setCloseFacilityInventoryAddData(false));
    console.log("err: ", error);
  } finally {
    yield put(hideLoader());
  }
}

function* deleteFacilityInventoryAsync(action) {
  const { id } = action?.payload;
  try {
    yield put(showLoader());
    const response = yield FacilityManagementService.deleteFacilityInventory(id);
    const { status } = response;
    if (status) {
      const { message } = response?.data;
      eventEHRCustomToastMessage({
        title: `${message}`,
        status: "success",
      });
      yield put(setCloseFacilityInventoryAddData(true));
    }
  } catch (error) {
    eventEHRCustomToastMessage({
      title: `${error?.response?.data?.message}`,
      status: "error",
    });
    yield put(setCloseFacilityInventoryAddData(false));
    console.log("err: ", error);
  } finally {
    yield put(hideLoader());
  }
}

// ADJUST INVENTORY: create notes (debits stock on backend)
function* postInventoryNotesAsync(action) {
  const { id, notes } = action?.payload;
  try {
    yield put(showLoader());
    const response = yield FacilityManagementService.postInventoryNotes(
      id,
      notes
    );
    const { status } = response;
    if (status) {
      const { message } = response?.data;
      eventEHRCustomToastMessage({ title: `${message}`, status: "success" });
      yield put(setCloseAddNotesDialog(true));
    }
  } catch (error) {
    eventEHRCustomToastMessage({
      title: `${error?.response?.data?.message}`,
      status: "error",
    });
    yield put(setCloseAddNotesDialog(false));
    console.log("err: ", error);
  } finally {
    yield put(hideLoader());
  }
}

// GET notes grouped by ids (view dialog + bulk summary)
function* getInventoryNotesGroupedByIdsAsync(action) {
  const { ids } = action?.payload;
  try {
    yield put(showLoader());
    const response =
      yield FacilityManagementService.getInventoryNotesGroupedByIds(ids);
    const { status } = response;
    if (status) {
      yield put(setGroupedNotesData(response?.data?.data || []));
    }
  } catch (error) {
    eventEHRCustomToastMessage({
      title: `${error?.response?.data?.message}`,
      status: "error",
    });
    yield put(setGroupedNotesData([]));
    console.log("err: ", error);
  } finally {
    yield put(hideLoader());
  }
}

// TRANSFER inventory to pharmacy/facility (single + bulk)
function* postBulkTransferAsync(action) {
  try {
    yield put(showLoader());
    const response = yield FacilityManagementService.postBulkTransfer(
      action?.payload
    );
    const { status } = response;
    if (status) {
      const { message } = response?.data;
      eventEHRCustomToastMessage({ title: `${message}`, status: "success" });
      yield put(setCloseSendBulkDialog(true));
    }
  } catch (error) {
    eventEHRCustomToastMessage({
      title: `${error?.response?.data?.message}`,
      status: "error",
    });
    yield put(setCloseSendBulkDialog(false));
    console.log("err: ", error);
  } finally {
    yield put(hideLoader());
  }
}

// GET TASK DATA ASYNC
function* getRolesListAsync(action) {
  try {
    yield put(showLoader());
    const response = yield FacilityManagementService.getRolesList(
      action?.payload
    );
    const { status, data } = response;
    if (status) {
      yield put(setRolesList(data?.roles));
    }
  } catch (error) {
    eventEHRCustomToastMessage({
      title: `${error?.response?.data?.message}`,
      status: "error",
    });
    yield put(setRolesList({}));
    console.log("err: ", error);
  } finally {
    yield put(hideLoader());
  }
}

function* addNewFacilityUserAsync(action) {
  try {
    yield put(showLoader);
    const response = yield FacilityManagementService.addNewFacilityUser(
      action?.payload
    );

    const { status, data } = response;
    if (status) {
      const { message } = data;
      eventEHRCustomToastMessage({
        title: `${message}`,
        status: "success",
      });
      yield put(setCloseUserDialog(true));
    }
  } catch (error) {
    eventEHRCustomToastMessage({
      title: `${error?.response?.data?.message}`,
      status: "error",
    });
    yield put(setCloseUserDialog(false));
    console.log("err: ", error);
  } finally {
    yield put(hideLoader());
  }
}

// GET TASK DATA ASYNC
function* getFacilityUserListAsync(action) {
  try {
    yield put(showLoader());
    const response = yield FacilityManagementService.getFacilityUserList(
      action?.payload
    );
    const { status, data } = response;
    if (status) {
      yield put(setFacilityUserList(data));
    }
  } catch (error) {
    eventEHRCustomToastMessage({
      title: `${error?.response?.data?.message}`,
      status: "error",
    });
    yield put(setFacilityUserList({}));
    console.log("err: ", error);
  } finally {
    yield put(hideLoader());
  }
}

function* patchFacilityUserAsync(action) {
  const { id, payload } = action?.payload;
  try {
    yield put(showLoader());
    const response = yield FacilityManagementService.patchFacilityUser(
      id,
      payload
    );
    const { status } = response;
    if (status) {
      const { data, message } = response?.data;

      eventEHRCustomToastMessage({
        title: `${message}`,
        status: "success",
      });
      yield put(setCloseUserDialog(true));
    }
  } catch (error) {
    eventEHRCustomToastMessage({
      title: `${error?.response?.data?.message}`,
      status: "error",
    });
    yield put(setCloseUserDialog(false));
    console.log("err: ", error);
  } finally {
    yield put(hideLoader());
  }
}

// DELETE FACILITY USER ASYNC
function* deleteFacilityUserAsync(action) {
  console.log("deleteFacilityUserAsync called with action:", action);
  const { id } = action?.payload;
  console.log("Extracted ID:", id);
  try {
    yield put(showLoader());
    const response = yield FacilityManagementService.deleteFacilityUser(id);
    console.log("Delete API response:", response);
    const { status } = response;
    if (status) {
      const { data, message } = response?.data;
      console.log(data);

      eventEHRCustomToastMessage({
        title: `${message}`,
        status: "success",
      });
      yield put(setCloseUserDialog(true));
    }
  } catch (error) {
    console.log("Delete API error:", error);
    eventEHRCustomToastMessage({
      title: `${error?.response?.data?.message}`,
      status: "error",
    });
    yield put(setCloseUserDialog(false));
    console.log("err: ", error);
  } finally {
    yield put(hideLoader());
  }
}

// SEND FACILITY USER INVITATION ASYNC
function* sendFacilityUserInvitationAsync(action) {
  const { id } = action?.payload;
  try {
    yield put(showLoader());
    const response = yield FacilityManagementService.sendFacilityUserInvitation(
      id
    );
    const { status } = response;
    if (status) {
      const { message } = response?.data;
      eventEHRCustomToastMessage({
        title: `${message}`,
        status: "success",
      });
    }
  } catch (error) {
    eventEHRCustomToastMessage({
      title: `${error?.response?.data?.message}`,
      status: "error",
    });
    console.log("err: ", error);
  } finally {
    yield put(hideLoader());
  }
}

// SEND FACILITY USER BULK INVITATION ASYNC
function* sendFacilityUserBulkInvitationAsync(action) {
  const { ids } = action?.payload;
  try {
    yield put(showLoader());
    const response =
      yield FacilityManagementService.sendFacilityUserBulkInvitation(ids);
    const { status } = response;
    if (status) {
      const { message } = response?.data;
      eventEHRCustomToastMessage({
        title: `${message}`,
        status: "success",
      });
    }
  } catch (error) {
    eventEHRCustomToastMessage({
      title: `${error?.response?.data?.message}`,
      status: "error",
    });
    console.log("err: ", error);
  } finally {
    yield put(hideLoader());
  }
}

// DELETE FACILITY ASYNC
function* deleteFacilityAsync(action) {
  const { facilityId, force = false } = action?.payload;
  try {
    yield put(showLoader());
    const response = yield FacilityManagementService.deleteFacility(
      facilityId,
      force
    );
    const { status } = response;
    
    // Store response in state for component to access
    yield put(setDeleteFacilityResponse({
      success: status,
      data: response?.data,
      force: force,
    }));

    if (status) {
      const { data, message } = response?.data;
      eventEHRCustomToastMessage({
        title: `${message}`,
        status: "success",
      });
      // Refresh facility list after successful deletion
      const currentState = store.getState();
      const facilityState = currentState[componentKey];
      if (facilityState?.facilityList) {
        yield put(
          getFacilityList({
            pageNumber: 1,
            limit: "5",
          })
        );
      }
    }
  } catch (error) {
    // Store error response in state
    yield put(setDeleteFacilityResponse({
      success: false,
      data: error?.response?.data || { message: "Failed to delete facility" },
      force: force,
    }));
    eventEHRCustomToastMessage({
      title: `${error?.response?.data?.message || "Failed to delete facility"}`,
      status: "error",
    });
    console.log("err: ", error);
  } finally {
    yield put(hideLoader());
  }
}

// DELETE DEPARTMENT ASYNC
function* deleteDepartmentAsync(action) {
  const { departmentId, force = false } = action?.payload;
  try {
    yield put(showLoader());
    const response = yield FacilityManagementService.deleteDepartment(
      departmentId,
      force
    );
    const { status } = response;
    
    // Store response in state for component to access
    yield put(setDeleteDepartmentResponse({
      success: status,
      data: response?.data,
      force: force,
    }));

    if (status) {
      const { data, message } = response?.data;
      eventEHRCustomToastMessage({
        title: `${message}`,
        status: "success",
      });
    }
  } catch (error) {
    // Store error response in state
    yield put(setDeleteDepartmentResponse({
      success: false,
      data: error?.response?.data || { message: "Failed to delete department" },
      force: force,
    }));
    eventEHRCustomToastMessage({
      title: `${error?.response?.data?.message || "Failed to delete department"}`,
      status: "error",
    });
    console.log("err: ", error);
  } finally {
    yield put(hideLoader());
  }
}

function* rootSaga() {
  yield all([takeLatest(getFacilityList().type, getFacilityListAsync)]);
  yield all([takeLatest(postFacilityData().type, postFacilityDataAsync)]);
  yield all([takeLatest(patchFacilityData().type, patchFacilityDataAsync)]);
  yield all([takeLatest(getFacilityById().type, getFacilityByIdAsync)]);
  yield all([takeLatest(addDepartment().type, addDepartmentAsync)]);
  yield all([takeLatest(getDepartmentList().type, getDepartmentListAsync)]);
  yield all([takeLatest(addRoom().type, addRoomAsync)]);
  yield all([takeLatest(getRoomList().type, getRoomListAsync)]);
  yield all([takeLatest(patchRoomData().type, patchRoomDataAsync)]);
  yield all([takeLatest(deleteRoom().type, deleteRoomAsync)]);
  yield all([takeLatest(patchDepartmentData().type, patchDepartmentDataAsync)]);
  yield all([takeLatest(getClinicLocations().type, getClinicLocationsAsync)]);
  yield all([takeLatest(getPatientList().type, getPatientListAsync)]);
  yield all([takeLatest(createNewPatient().type, createNewPatientAsync)]);
  yield all([
    takeLatest(getFacilityInventoryList().type, getFacilityInventoryListAsync),
  ]);
  yield all([
    takeLatest(
      createFacilityInventory().type,
      createFacilityInventoryDataAsync
    ),
  ]);
  yield all([
    takeLatest(
      patchAddFacilityInventory().type,
      patchAddFacilityInventoryDataAsync
    ),
  ]);
  yield all([
    takeLatest(
      deleteFacilityInventory().type,
      deleteFacilityInventoryAsync
    ),
  ]);
  yield all([
    takeLatest(postInventoryNotes().type, postInventoryNotesAsync),
    takeLatest(
      getInventoryNotesGroupedByIds().type,
      getInventoryNotesGroupedByIdsAsync
    ),
    takeLatest(postBulkTransfer().type, postBulkTransferAsync),
  ]);
  yield all([takeLatest(getRolesList().type, getRolesListAsync)]);
  yield all([takeLatest(addNewFacilityUser().type, addNewFacilityUserAsync)]);
  yield all([takeLatest(getFacilityUserList().type, getFacilityUserListAsync)]);
  yield all([takeLatest(patchFacilityUser().type, patchFacilityUserAsync)]);
  yield all([takeLatest(deleteFacilityUser().type, deleteFacilityUserAsync)]);
  yield all([
    takeLatest(
      sendFacilityUserInvitation().type,
      sendFacilityUserInvitationAsync
    ),
  ]);
  yield all([
    takeLatest(
      sendFacilityUserBulkInvitation().type,
      sendFacilityUserBulkInvitationAsync
    ),
  ]);
  yield all([takeLatest(deleteFacility().type, deleteFacilityAsync)]);
  yield all([takeLatest(deleteDepartment().type, deleteDepartmentAsync)]);
}

store.sagaManager.addSaga(componentKey, rootSaga);
